import { render, staticRenderFns } from "./productBigImg.vue?vue&type=template&id=16383786&scoped=true&"
import script from "./productBigImg.vue?vue&type=script&lang=js&"
export * from "./productBigImg.vue?vue&type=script&lang=js&"
import style0 from "./productBigImg.vue?vue&type=style&index=0&id=16383786&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16383786",
  null
  
)

export default component.exports